import { useState } from "react";
import { faqList } from "@/mocks/anime";

export default function Faq() {
  const [open, setOpen] = useState<string | null>("faq-01");

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-primary-600 font-bold text-sm">
            <i className="ri-question-line text-lg"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-900">
            关于小狗看番，你想知道的都在这里
          </h2>
        </div>

        <div className="space-y-3">
          {faqList.map((item) => {
            const isOpen = open === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-2xl overflow-hidden transition-colors ${
                  isOpen ? "bg-background-100 border border-primary-200" : "bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-bold text-foreground-900 text-sm md:text-base">
                    {item.question}
                  </span>
                  <i
                    className={`text-primary-600 text-lg transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}